import React from "react";
import { useNavigate } from "react-router-dom";
import { RecuperarSenhaForm } from "../design-system/components/recuperarsenha/RecuperarSenhaForm";


export default function RecuperarSenha(){

  const navigate = useNavigate();


  function handleSubmit(data){

    console.log("Email para recuperar:", data);


    navigate("/email-enviado", {
      state: {
        email: data.email
      }
    });

  }


  return (

    <div className="
      min-h-screen
      bg-background
      flex
      items-center
      justify-center
      px-6
    ">

      <RecuperarSenhaForm
        onSubmit={handleSubmit}
      />

    </div>

  );

}